import React, { useEffect, useState } from 'react';
import { getCookie, clearQueryParams, getUserCases,  getExpireDate, getCurrentUser} from '../../functions/utils'; // Import the utility functionimport '../../css/ImportComponent.css';
import ImportHeaderComponent from '../page/ImportHeaderComponent';
import LoaderComponent from '../utilities/LoaderComponent';
import MultiversLogo from '../../images/MultiversLogo.png';
import { useTranslations  } from '../utilities/TranslationContext';

// Import the core library and icon packs you need
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faChevronDown, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Add the icons you will use to the library
library.add(faChevronDown, faXmark, faArrowLeft);

const MultiversCallbackComponent = () => {
  const { getTranslation } = useTranslations();
  const [link, setLink] = useState("");

  const handleChangeLink = (e) => {
    setLink(e.target.value);
  };

  useEffect(() =>{
    const queryParams = new URLSearchParams(window.location.search);
    if(queryParams.get("code")){
      document.cookie = `multivers_auth=${queryParams.get("code")}; path=/`;
      fetchTokens(queryParams.get("code"));
    }
  },[]);

  // Handles the initial exact online setup
  async function init(){ 
   
  }
  async function fetchTokens(authcode){
    var currentUser = await getCurrentUser();
    if(currentUser){
      const response = await fetch('/multivers/fetchTokens?authcode='+authcode+"&current_user="+currentUser);
      if (response.ok) {
        const responseData = await response.json();
    
          if(responseData){
            console.log(responseData);
            window.location.href = '/app?import=multivers';
          }
      }
    }
  }
  async function test(){
    var currentUser = await getCurrentUser();
    if(currentUser){
      const response = await fetch("/multivers/fetchLink?link="+link+"&current_user="+currentUser);
      if (response.ok) {
        const responseData = await response.json();
    
          if(responseData){
            console.log(responseData);
          }
      }
    }else{
      return await test();
    }
  }
  async function testAccount(){
    var currentUser = await getCurrentUser();
    if(currentUser){
      const response = await fetch("/multivers/testAccount?current_user="+currentUser);
      if (response.ok) {
        const responseData = await response.json();
    
          if(responseData){
            console.log(responseData);
          }
      }
    }else{
      return await testAccount();
    }
  }
  // Redirect to home page event
  async function handleBackClicked(){
    window.location.href = '/app'
  }

  return (
    <div className="import-container">
      <ImportHeaderComponent
        title="Multivers"
        logo={MultiversLogo}
        subtitle={getTranslation('import_MultiversSubtitle')}
      />
      <div className="import-component-container">
        <input value={link} onChange={handleChangeLink} />
        <button className="import-btn hover" onClick={()=>{test();}}>Test</button> 
        <button className="import-btn hover" onClick={()=>{testAccount();}}>Account</button> 
      </div>
    </div>
  );
}

export default MultiversCallbackComponent;
